"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var useCrudWithListPattern_1 = require("../hooks/useCrudWithListPattern");
var morse_react_1 = require("morse-react");
var formik_1 = require("formik");
var AcornListScreen_1 = require("./list/AcornListScreen");
var react_router_dom_1 = require("react-router-dom");
var acorn_react_core_1 = require("@gcdtech/acorn-react-core");
var LoadItemWrapper = function (props) {
    react_1.useEffect(function () {
        props.crud.itemFetchingState.fetch(props.itemId);
    }, [props.itemId]);
    // Until the fetching is running slow, we don't show anything to try
    // and reduce flicker.
    if (props.crud.itemFetchingState.fetched || props.crud.itemFetchingState.fetchingSlowlyDebounced) {
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: props.children }, void 0);
    }
    else {
        return null;
    }
};
var CrudContainer = function (props) {
    var _a, _b;
    var routeMatch = react_router_dom_1.useRouteMatch();
    if (!props.path) {
        props.path = routeMatch.path;
    }
    var crud = useCrudWithListPattern_1.useCrudWithListPattern(props.api, props.fetchListOptions);
    var history = react_router_dom_1.useHistory();
    var _c = props.screenMode, screenMode = _c === void 0 ? acorn_react_core_1.ScreenMode.Screen : _c, _d = props.listComponent, ListComponent = _d === void 0 ? AcornListScreen_1.AcornListScreen : _d;
    var feedback = acorn_react_core_1.useFeedback();
    var saveItem = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var newItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!item.id) return [3 /*break*/, 2];
                    return [4 /*yield*/, crud.updateItem(item)];
                case 1:
                    newItem = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, crud.createItem(item)];
                case 3:
                    newItem = _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, newItem];
            }
        });
    }); };
    var saveAndReturnToList = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var newItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveItem(item)];
                case 1:
                    newItem = _a.sent();
                    return [4 /*yield*/, crud.listFetchingState.refetch()];
                case 2:
                    _a.sent();
                    history.push(listPath);
                    return [2 /*return*/, newItem];
            }
        });
    }); };
    var listTitle = morse_react_1.wordifyCamelCase((_b = (_a = props.crudSettings) === null || _a === void 0 ? void 0 : _a.pluralItemName) !== null && _b !== void 0 ? _b : morse_react_1.makePlural(props.crudSettings.itemName));
    var listPath = routeMatch.url;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs(react_router_dom_1.Switch, { children: [props.createItemComponent && (jsx_runtime_1.jsx(react_router_dom_1.Route, { path: props.path + '/create', exact: false, render: function () {
                            var _a;
                            return (jsx_runtime_1.jsx(formik_1.Formik, __assign({ initialValues: ((_a = props.createItemInitialValues) !== null && _a !== void 0 ? _a : {}), onSubmit: function (values, _a) {
                                    var setErrors = _a.setErrors;
                                    return __awaiter(void 0, void 0, void 0, function () {
                                        var newItem, e_1;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    _b.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, saveAndReturnToList(values)];
                                                case 1:
                                                    newItem = _b.sent();
                                                    feedback.addFeedback({
                                                        type: acorn_react_core_1.CommonFeedbackType.RecordCreated,
                                                        message: (jsx_runtime_1.jsxs("p", { children: ["The", ' ', jsx_runtime_1.jsx(react_router_dom_1.Link, __assign({ to: props.path + "/" + newItem.id }, { children: props.crudSettings.itemName }), void 0), ' ', "was created successfully."] }, void 0)),
                                                    });
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    e_1 = _b.sent();
                                                    setErrors(e_1.response.data.errors);
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    });
                                }, validationSchema: props.validationSchema }, { children: function (_a) {
                                    var _b, _c;
                                    var isSubmitting = _a.isSubmitting, values = _a.values, handleSubmit = _a.handleSubmit;
                                    var Component = props.createItemComponent;
                                    return (jsx_runtime_1.jsx(morse_react_1.Form, __assign({ inline: true, grid: true }, { children: jsx_runtime_1.jsx(Component, __assign({ mode: props.screenMode, title: "Create a new " + ((_c = (_b = props.crudSettings) === null || _b === void 0 ? void 0 : _b.itemName) !== null && _c !== void 0 ? _c : 'item'), crumbs: [{ path: props.path, name: listTitle }], crudData: crud, itemFetchingState: crud.itemFetchingState, item: {} }, props, props.createItemProps, { onSaveItem: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, saveItem(values)];
                                                });
                                            }); }, buttons: [
                                                jsx_runtime_1.jsx(morse_react_1.Button, __assign({ onClick: function (e) {
                                                        // Note that to support dialogs (which are lifted out from their form contenxt in the DOM)
                                                        // we can't use a submit button we have to use a normal onClick and tell formik to
                                                        // handle the submit manually
                                                        e.preventDefault();
                                                        handleSubmit();
                                                    }, disabled: isSubmitting, busy: isSubmitting }, { children: "Save" }), void 0),
                                                jsx_runtime_1.jsx(morse_react_1.Button, __assign({ onClick: function () {
                                                        history.push(props.path);
                                                    }, disabled: isSubmitting, appearance: morse_react_1.Button.Appearance.Ghost }, { children: "Cancel" }), void 0),
                                            ] }), void 0) }), void 0));
                                } }), void 0));
                        } }, void 0)), jsx_runtime_1.jsx(react_router_dom_1.Route, { path: props.path + '/:itemId?(/edit)?', exact: false, render: function (_a) {
                            var _b;
                            var match = _a.match;
                            var isEditing = match.url.match('edit$') || !props.viewItemComponent;
                            var Component = isEditing ? props.updateItemComponent : props.viewItemComponent;
                            var FormWrap = isEditing ? morse_react_1.Form : react_1.default.Fragment;
                            return (jsx_runtime_1.jsx(LoadItemWrapper, __assign({ itemId: match.params.itemId, crud: crud }, { children: jsx_runtime_1.jsx(formik_1.Formik, __assign({ enableReinitialize: true, initialValues: (_b = crud.item) !== null && _b !== void 0 ? _b : {}, onSubmit: function (values, _a) {
                                        var setErrors = _a.setErrors;
                                        return __awaiter(void 0, void 0, void 0, function () {
                                            var e_2;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0:
                                                        _b.trys.push([0, 2, , 3]);
                                                        return [4 /*yield*/, saveAndReturnToList(values)];
                                                    case 1:
                                                        _b.sent();
                                                        feedback.addFeedback({
                                                            type: acorn_react_core_1.CommonFeedbackType.RecordCreated,
                                                            message: (jsx_runtime_1.jsxs("p", { children: ["The ", props.crudSettings.itemName, " was updated successfully."] }, void 0)),
                                                        });
                                                        return [3 /*break*/, 3];
                                                    case 2:
                                                        e_2 = _b.sent();
                                                        setErrors(e_2.response.data.errors);
                                                        return [3 /*break*/, 3];
                                                    case 3: return [2 /*return*/];
                                                }
                                            });
                                        });
                                    }, validationSchema: props.validationSchema }, { children: function (_a) {
                                        var _b, _c, _d;
                                        var isSubmitting = _a.isSubmitting, values = _a.values, handleSubmit = _a.handleSubmit;
                                        return (jsx_runtime_1.jsx(FormWrap, __assign({ inline: true, grid: true }, { children: jsx_runtime_1.jsx(Component, __assign({ crudData: crud, item: crud.item, itemFetchingState: crud.itemFetchingState, crumbs: [{ path: props.path, name: listTitle }], title: (isEditing
                                                    ? "Update " + ((_c = (_b = props.crudSettings) === null || _b === void 0 ? void 0 : _b.itemName) !== null && _c !== void 0 ? _c : 'item')
                                                    : morse_react_1.wordifyCamelCase((_d = props.crudSettings.itemName) !== null && _d !== void 0 ? _d : 'item')) +
                                                    ' ' +
                                                    match.params.itemId, onDismissed: function () {
                                                    history.push(props.path);
                                                }, allowDismiss: true, mode: props.screenMode, buttons: crud.itemFetchingState.fetched &&
                                                    !crud.itemFetchingState.fetchingSlowlyDebounced
                                                    ? [
                                                        jsx_runtime_1.jsx(morse_react_1.Button, __assign({ onClick: function (e) {
                                                                // Note that to support dialogs (which are lifted out from their form contenxt in the DOM)
                                                                // we can't use a submit button we have to use a normal onClick and tell formik to
                                                                // handle the submit manually
                                                                e.preventDefault();
                                                                handleSubmit();
                                                            }, disabled: isSubmitting, busy: isSubmitting }, { children: "Save" }), "save"),
                                                        jsx_runtime_1.jsx(morse_react_1.Button, __assign({ onClick: function () {
                                                                history.push(props.path);
                                                            }, disabled: isSubmitting, appearance: morse_react_1.Button.Appearance.Ghost }, { children: "Cancel" }), "cancel"),
                                                    ]
                                                    : [] }, props, props.updateItemProps, { onSaveItem: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        return [2 /*return*/, saveItem(values)];
                                                    });
                                                }); } }), void 0) }), void 0));
                                    } }), void 0) }), void 0));
                        } }, void 0)] }, void 0), ListComponent && (jsx_runtime_1.jsx(react_router_dom_1.Route, { path: listPath, exact: screenMode === acorn_react_core_1.ScreenMode.Screen ? true : false, render: function () { return (jsx_runtime_1.jsx(ListComponent, __assign({ crud: crud, hasCreateComponent: !!props.createItemComponent, hasViewComponent: !!props.viewItemComponent, hasUpdateComponent: !!props.updateItemComponent, crudSettings: props.crudSettings, items: crud.listFetchingState.items, listFetchingState: crud.listFetchingState, onItemSelected: function (itemId) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            history.push(props.path + '/' + itemId);
                            return [2 /*return*/];
                        });
                    }); }, criteria: crud.listFetchingState.request.criteria, range: crud.listFetchingState.request.range, sorts: crud.listFetchingState.request.sorts, onPageChanged: function (pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, crud.listFetchingState.changePageNumber(pageNumber)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onCriteriaChange: function (criteria) {
                        return crud.listFetchingState.fetch(__assign(__assign({}, crud.listFetchingState.request), { criteria: criteria, range: __assign(__assign({}, crud.listFetchingState.request.range), { 
                                // Always reset the page to page 1
                                offset: 0 }) }));
                    }, onRangeChange: function (range) {
                        return crud.listFetchingState.fetch(__assign(__assign({}, crud.listFetchingState.request), { range: range }));
                    }, onSortChange: function (sorts) {
                        return crud.listFetchingState.fetch(__assign(__assign({}, crud.listFetchingState.request), { sorts: sorts }));
                    }, onRequestChange: function (request) {
                        return crud.listFetchingState.fetch(request);
                    } }, props.listProps), void 0)); } }, void 0))] }, void 0));
};
exports.CrudContainer = CrudContainer;
//# sourceMappingURL=CrudContainer.js.map